import removeBlock from './removeBlock';

export default function removeEmptyBlocks(contentState) {
  const blockMap = contentState.getBlockMap();
  let newContentState = contentState;

  blockMap.forEach((currentBlock) => { // eslint-disable-line consistent-return
    if (newContentState.getBlockMap().size === 1) { // we should keep at least 1 block
      return false;
    }
    if (isBlockEmpty(currentBlock)) {
      newContentState = removeBlock(newContentState, currentBlock.get('key'));
    }
  });

  return newContentState;
}

function isBlockEmpty(block) {
  return !block.getLength();
}
